import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const RowKeyVal = ({ arr }) => {
    return (_jsx("div", { className: "row mb-2", children: arr.map((prop) => (_jsxs("div", { className: "col-md-6", children: [_jsxs("b", { children: [prop.key, ":"] }), " ", prop.elementVal ?? prop.val ?? ""] }, prop.key))) }));
};
